import React from 'react';
import styled from 'styled-components';
import theme from '../utils/theme';
import MainBanner from './common/MainBanner';

export default function LoanProductGrid() {
  const carSvg = (
    <svg width="60" height="60" viewBox="0 0 24 24" fill="none">
      <path d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.22.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z" fill="white" stroke="white" strokeWidth="1.0" />
    </svg>
  );
  const documentSvg = (
    <svg width="60" height="60" viewBox="0 0 24 24" fill="none">
      <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z" fill="white" stroke="white" strokeWidth="1.0" />
    </svg>
  );
  const moneySvg = (
    <svg width="60" height="60" viewBox="0 0 24 24" fill="none">
      <path d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z" fill="white" stroke="white" strokeWidth="1.0" />
    </svg>
  );
  const plusSvg = (
    <svg width="60" height="60" viewBox="0 0 24 24" fill="none">
      <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" fill="white" stroke="white" strokeWidth="1.0" />
    </svg>
  );

  return (
    <MainBanner>
      <BannerDiv>
        <SectionTitle>
          한도는 높이고<br />
          금리는 낮추고
          <TitleUnderline />
        </SectionTitle>
        <ProductGrid>
          <ProductCard>
            <IconCircle>
              <CarIcon>{carSvg}</CarIcon>
            </IconCircle>
            <CardText>타던 차 그대로<br />
              신규대출</CardText>
          </ProductCard>
          <ProductCard>
            <IconCircle>
              <DocumentIcon>{documentSvg}</DocumentIcon>
            </IconCircle>
            <CardText>신차 할부 후<br />
              추가대출</CardText>
          </ProductCard>
          <ProductCard>
            <IconCircle>
              <MoneyIcon>{moneySvg}</MoneyIcon>
            </IconCircle>
            <CardText>중고차 할부 후<br />
              추가대출</CardText>
          </ProductCard>
          <ProductCard>
            <IconCircle>
              <PlusIcon>{plusSvg}</PlusIcon>
            </IconCircle>
            <CardText>차량통합대출<br />
              (대환+추가대출)</CardText>
          </ProductCard>
        </ProductGrid>
      </BannerDiv>
    </MainBanner>
  );
}

const BannerDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`;

const SectionTitle = styled.h2`
  color: ${theme.navyColor};
  font-size: 36px;
  font-weight: 700;
  margin-bottom: 40px;
  position: relative;
`;

const TitleUnderline = styled.div`
  width: 60px;
  height: 3px;
  background: ${theme.mainColor};
  margin: 16px auto 0;
  border-radius: 2px;
`;

const ProductGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  max-width: 600px;

`;

const ProductCard = styled.div`
  background: #ffffff;
  border-radius: 16px;
  padding: 24px 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  transition: transform 0.3s ease;
  
  &:hover {
    transform: translateY(-4px);
  }
`;

const IconCircle = styled.div`
  width: 75px;
  height: 75px;
  background: ${theme.mainColor};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  
  svg {
    margin-top: 5px;
  }
`;

const CarIcon = styled.div`
  svg {
    width: 40px;
    height: 40px;
  }
`;

const DocumentIcon = styled.div`
  svg {
    width: 40px;
    height: 40px;
  }
`;

const MoneyIcon = styled.div`
  svg {
    width: 40px;
    height: 40px;
  }
`;

const PlusIcon = styled.div`
  svg {
    width: 40px;
    height: 40px;
  }
`;

const CardText = styled.p`
  color: ${theme.navyColor};
  font-size: 16px;
  font-weight: 500;
  line-height: 1.4;
  margin: 0;
  text-align: center;
`; 